export default __webpack_public_path__ + "static/media/form-image.4657a5e5.png";